import { Injectable } from '@angular/core';

import { ColDef } from 'ag-grid-enterprise';

import { CommonColumnDefinitionService } from './common-column-definition.service';

@Injectable()
export class VitescoColumnDefinitionService extends CommonColumnDefinitionService {
  AUTO_GROUP_COLUMN_DEF: ColDef = {
    ...this.AUTO_GROUP_COLUMN_DEF,
    field: 'semi',
  };

  COLUMN_DEFINITION: ColDef[] = [
    {
      field: 'level',
      headerName: 'level',
      type: 'numericColumn',
    },
    {
      field: 'hierarchy',
      headerName: 'hierarchy',
    },
    { field: 'plant', headerName: 'plant' },
    { field: 'plantName', headerName: 'plantName' },
    { field: 'description', headerName: 'description' },
    { field: 'supplyingPlant', headerName: 'supplyingPlant' },
    { field: 'supplyingPlantName', headerName: 'supplyingPlantName' },
    { field: 'semi', headerName: 'semi' },
    { field: 'semiName', headerName: 'semiName' },
    { field: 'fin', headerName: 'fin' },
    { field: 'finName', headerName: 'finName' },
    { field: 'costCenter', headerName: 'costCenter' },
    { field: 'costCenterName', headerName: 'costCenterName' },
    { field: 'workCenter', headerName: 'workCenter', type: 'numericColumn' },
    { field: 'workCenterName', headerName: 'workCenterName' },
    { field: 'activityType', headerName: 'activityType' },
    { field: 'material', headerName: 'material' },
    { field: 'materialName', headerName: 'materialName' },
    { field: 'currencyFin', headerName: 'currencyFin' },
    { field: 'currencySupply', headerName: 'currencySupply' },
    {
      field: 'crossFxBud2026',
      headerName: 'crossFxBud2026',
      type: 'numericColumn',
    },
    {
      field: 'quantityPerSemi',
      headerName: 'quantityPerSemi',
      type: 'numericColumn',
    },
    {
      field: 'quantityPerFin',
      headerName: 'quantityPerFin',
      type: 'numericColumn',
    },
    { field: 'semiQty', headerName: 'semiQty', type: 'numericColumn' },
    { field: 'unit', headerName: 'unit' },
    { field: 'quantity', headerName: 'quantity', type: 'numericColumn' },
    {
      field: 'productionOvhdFinCurr',
      headerName: 'productionOvhdFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'scrapFinCurr',
      headerName: 'scrapFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'directPersonnelExpensesFinCurr',
      headerName: 'directPersonnelExpensesFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'otherOverheadExpensesFinCurr',
      headerName: 'otherOverheadExpensesFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'depreciationAndAmortizationFinCurr',
      headerName: 'depreciationAndAmortizationFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'maintenanceFinCurr',
      headerName: 'maintenanceFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'operatingSuppliesFinCurr',
      headerName: 'operatingSuppliesFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'toolCostsFinCurr',
      headerName: 'toolCostsFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'plantOverheadFinCurr',
      headerName: 'plantOverheadFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'costsOfTemporaryEmployeesFinCurr',
      headerName: 'costsOfTemporaryEmployeesFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'corporateOverheadFinCurr',
      headerName: 'corporateOverheadFinCurr',
      type: 'numericColumn',
    },
    { field: 'rawFinCurr', headerName: 'rawFinCurr', type: 'numericColumn' },
    {
      field: 'inboundHFFinCurr',
      headerName: 'inboundHFFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'supplierToolingFinCurr',
      headerName: 'supplierToolingFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'customsFinCurr',
      headerName: 'customsFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'outsourcedLabourFinCurr',
      headerName: 'outsourcedLabourFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'materialOvhdFinCurr',
      headerName: 'materialOvhdFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'totalCostsFinCurr',
      headerName: 'totalCostsFinCurr',
      type: 'numericColumn',
    },
    {
      field: 'productionOvhdInEur',
      headerName: 'productionOvhdInEur',
      type: 'numericColumn',
    },
    { field: 'scrapInEur', headerName: 'scrapInEur', type: 'numericColumn' },
    {
      field: 'directPersonnelExpensesInEur',
      headerName: 'directPersonnelExpensesInEur',
      type: 'numericColumn',
    },
    {
      field: 'otherOverheadExpensesInEur',
      headerName: 'otherOverheadExpensesInEur',
      type: 'numericColumn',
    },
    {
      field: 'depreciationAndAmortizationInEur',
      headerName: 'depreciationAndAmortizationInEur',
      type: 'numericColumn',
    },
    {
      field: 'maintenanceInEur',
      headerName: 'maintenanceInEur',
      type: 'numericColumn',
    },
    {
      field: 'operatingSuppliesInEur',
      headerName: 'operatingSuppliesInEur',
      type: 'numericColumn',
    },
    {
      field: 'toolCostsInEur',
      headerName: 'toolCostsInEur',
      type: 'numericColumn',
    },
    {
      field: 'plantOverheadInEur',
      headerName: 'plantOverheadInEur',
      type: 'numericColumn',
    },
    {
      field: 'costsOfTemporaryEmployeesInEur',
      headerName: 'costsOfTemporaryEmployeesInEur',
      type: 'numericColumn',
    },
    {
      field: 'corporateOverheadInEur',
      headerName: 'corporateOverheadInEur',
      type: 'numericColumn',
    },
    { field: 'rawInEur', headerName: 'rawInEur', type: 'numericColumn' },
    {
      field: 'inboundHFInEur',
      headerName: 'inboundHFInEur',
      type: 'numericColumn',
    },
    {
      field: 'supplierToolingInEur',
      headerName: 'supplierToolingInEur',
      type: 'numericColumn',
    },
    {
      field: 'customsInEur',
      headerName: 'customsInEur',
      type: 'numericColumn',
    },
    {
      field: 'outsourcedLabourInEur',
      headerName: 'outsourcedLabourInEur',
      type: 'numericColumn',
    },
    {
      field: 'materialOvhdInEur',
      headerName: 'materialOvhdInEur',
      type: 'numericColumn',
    },
    {
      field: 'totalCostsInEur',
      headerName: 'totalCostsInEur',
      type: 'numericColumn',
    },
    {
      field: 'costCompOfAuxiliaryCcs',
      headerName: 'costCompOfAuxiliaryCcs',
      type: 'numericColumn',
    },
    { field: 'equalTo', headerName: 'equalTo', type: 'numericColumn' },
    { field: 'denominator', headerName: 'denominator', type: 'numericColumn' },
    { field: 'assemblyIndicator', headerName: 'assemblyIndicator' },
    { field: 'priceQuantityUnit', headerName: 'priceQuantityUnit' },
    { field: 'brand', headerName: 'brand' },
    { field: 'itemNumber', headerName: 'itemNumber', type: 'numericColumn' },
    {
      field: 'equalToInEur',
      headerName: 'equalToInEur',
      type: 'numericColumn',
    },
    {
      field: 'denominatorInEur',
      headerName: 'denominatorInEur',
      type: 'numericColumn',
    },
    { field: 'lotSize', headerName: 'lotSize', type: 'numericColumn' },
  ];
}
